<!-- Preview Controls -->
<ng-container *ngIf="!previewIsMobile">
  <div class="email-preview-controls">
    <ng-container *ngIf="loadingIndicator">
      <div class="tiny-loading-indicator">
        <glxy-loading-spinner [inline]="true"></glxy-loading-spinner>
      </div>
    </ng-container>

    <ng-container *ngIf="showDevicePreviewSizeButtons">
      <glxy-button-group class="device-preview-size">
        <ng-container *ngIf="showDesktopButton">
          <button
            mat-stroked-button
            (click)="previewSizeClicked('desktop')"
            [ngClass]="{
              selected: previewSizeSelected === 'desktop'
            }"
          >
            <mat-icon>computer</mat-icon>
            {{ 'EMAIL_EDITOR_PREVIEW.DESKTOP' | translate }}
          </button>
        </ng-container>
        <button
          mat-stroked-button
          (click)="previewSizeClicked('tablet')"
          [ngClass]="{
            selected: previewSizeSelected === 'tablet'
          }"
        >
          <mat-icon>tablet_mac</mat-icon>
          {{ 'EMAIL_EDITOR_PREVIEW.TABLET' | translate }}
        </button>
        <button
          (click)="previewSizeClicked('mobile')"
          mat-stroked-button
          [ngClass]="{
            selected: previewSizeSelected === 'mobile'
          }"
        >
          <mat-icon>phone_iphone</mat-icon>
          {{ 'EMAIL_EDITOR_PREVIEW.MOBILE' | translate }}
        </button>
      </glxy-button-group>
    </ng-container>
    <ng-content select="[email_preview_modal_close_button]"></ng-content>
  </div>
</ng-container>

<ng-content select="[preview_header]"></ng-content>
<!-- Email Preview and Sourcecode -->

<div class="preview-iframe-container">
  <iframe
    #iframePreview
    [style.max-width]="emailPreviewWidth"
    [style.min-height]="previewIsMobile ? '100vh' : null"
    sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    class="email-preview-iframe"
    [srcdoc]="previewIsMobile && _html ? (_html | iTrustThisHtml) : null"
    (load)="setIframeHeightOnMobile()"
  ></iframe>
  <ng-container *ngIf="!_html">
    <div class="email-loading-container">
      <glxy-loading-spinner [fullWidth]="true" [fullHeight]="true"></glxy-loading-spinner>
    </div>
  </ng-container>
  <div class="iframe-resize-protector"></div>
</div>
